import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { FAQApi } from 'shared/api/FAQApi'
import { FAQItem } from 'shared/api/FaqModel'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import { FaqAccordion, FaqStatus } from './components/faq-accordion'
import { SupportBanner } from './components/support-banner'
import styles from './styles.module.scss'

const Feedback = () => {
  const { t } = useTranslation()
  const [faqList, setFaqList] = useState<FAQItem[]>([])
  const [faqStatus, setFaqStatus] = useState<FaqStatus>('loading')

  const getFAQ = async () => {
    setFaqStatus('loading')

    try {
      const { data } = await FAQApi.getFaq()

      setFaqList(data.data || [])
      setFaqStatus('success')
    } catch (_) {
      setFaqList([])
      setFaqStatus('error')
    }
  }

  useEffect(() => {
    void getFAQ()
  }, [])

  return (
    <main className={styles.container}>
      <HeaderGoBack
        variant="grey"
        buttonWhite
        title={t('help_appeal')}
      />

      <SupportBanner />

      <FaqAccordion
        faqList={faqList}
        status={faqStatus}
        onRetry={() => void getFAQ()}
      />
    </main>
  )
}

export default Feedback
